let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("qT1OJ"), load("73Igd")]).then(() => parcelRequire('c6Xlh'));